import { Card, Stack, Title, Text, Group, type CardProps } from '@mantine/core';
import type { ReactNode } from 'react';

interface FormSectionProps extends Omit<CardProps, 'children'> {
  title: ReactNode;
  description?: ReactNode;
  rightSection?: ReactNode;
  children: ReactNode;
}

export function FormSection({
  title,
  description,
  rightSection,
  children,
  ...cardProps
}: FormSectionProps) {
  return (
    <Card padding="lg" radius="md" withBorder {...cardProps}>
      <Stack gap="md">
        <Group justify="space-between" align="flex-start">
          <Stack gap={2}>
            <Title order={3}>
              {title}
            </Title>
            {description && (
              <Text size="sm" c="vdzGray.7">
                {description}
              </Text>
            )}
          </Stack>
          {rightSection}
        </Group>
        {children}
      </Stack>
    </Card>
  );
}
